import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { autoinject, bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { PenOrderItem } from 'models/pen/PenOrderItem';
import { PenOrderItemService } from 'services/pen/pen-order-item-service';

@autoinject
export class PenOrderDetailsContainer {
  protected penOrderItems: Array<PenOrderItem>;
  protected subscription: Subscription;

  constructor(private router: Router, private penOrderItemService: PenOrderItemService, private eventAggregator: EventAggregator) {}

  @bindable
  protected penOrderId: number;
  @bindable
  protected penId: number;

  attached() {
    this.getPenOrderItems();

    this.subscription = this.eventAggregator.subscribe('pens-created', () => {
      this.getPenOrderItems();
    });
  }

  protected detached() {
    if (this.subscription) {
      this.subscription.dispose();
    }
  }

  private async getPenOrderItems() {
    this.penOrderItems = await this.penOrderItemService.getAll('?$filter=PenOrderId eq ' + this.penOrderId);
  }
}
